(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.desktopMatchQuery = window.matchMedia('(min-width: 990px)');
      this.slider = null;
      this.options = {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector('[data-arrow-prev]'),
          nextEl: this.querySelector('[data-arrow-next]'),
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: Number(this.getAttribute('data-autoplay')),
          rewind: true,
        };
      }
    }

    handleResize = debounce(() => {
      this.initSlider();
    }, 300);

    /**
     * Init slider.
     *
     * @returns {Void}
     */
    initSlider() {
      if (this.desktopMatchQuery.matches) {
        if (this.slider?.destroyed) return;
        return this.destroy();
      }
      if (!!this.querySelector('.swiper-initialized')) return;
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    /**
     * Destroy.
     */
    destroy() {
      typeof this.slider?.destroy === 'function' && this.slider.destroy(true, true);
    }

    /**
     * Toggle listeners.
     *
     * @param {Boolean} shouldRemove
     */
    toggleListeners(shouldRemove = false) {
      const method = shouldRemove ? 'removeEventListener' : 'addEventListener';
      window[method]('resize', this.handleResize);
    }

    /**
     * Disconnected callback.
     */
    disconnectedCallback() {
      this.toggleListeners('remove');
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');
      if (!this.sliderElement) return;

      this.toggleListeners();
      this.initSlider();
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();
